import AutocompleteInput, { Option } from '@/components/inputs/AutocompleteInput';

interface DriverSelectorProps {
  driver: Option | null;
  setDriver: (option: Option | null) => void;
  setDriverSearch: (search: string) => void;
  driverOptions: Option[];
  isDriversLoading: boolean;
}

const DriverSelector = ({
  driver,
  setDriver,
  setDriverSearch,
  driverOptions,
  isDriversLoading,
}: DriverSelectorProps) => {
  return (
    <div className='flex flex-col gap-2 text-base'>
      <label className='text-[13px] font-bold text-gray-400 uppercase tracking-widest px-1'>
        Seleccione el conductor
      </label>
      <AutocompleteInput
        name='driver-scanner'
        placeholder='Buscar conductor...'
        value={driver}
        onChange={setDriver}
        onInputChange={setDriverSearch}
        options={driverOptions}
        loading={isDriversLoading}
      />
    </div>
  );
};

export default DriverSelector;
